import React from 'react';
import ApplicantDetailsMain from './Applicant-Details-Main';

function ApplicantDetails() {
  return (
    <div className="main-content">
      <div className="main-content-bottom">
        <ApplicantDetailsMain/>
      </div>
    </div>
  );
}

export default ApplicantDetails;
